export enum PartnerNameType {
  FIRST_NAME = 'FIRST_NAME',
  MIDDLE_NAME = 'MIDDLE_NAME',
  LAST_NAME = 'LAST_NAME',
  BIRTH_NAME = 'BIRTH_NAME',
  LEGAL_NAME = 'LEGAL_NAME',
  SYNONYM = 'SYNONYM',
  NICKNAME = 'NICKNAME',
  PSEUDONYM = 'PSEUDONYM',
  ALTERNATIVE_ALPHABET = 'ALTERNATIVE_ALPHABET',
  ALTERNATIVE_NAME = 'ALTERNATIVE_NAME',
}

export default PartnerNameType;
